import React, { useState } from 'react';
import { LockClosedIcon, DocumentTextIcon } from '@heroicons/react/24/outline';

import { Button, Card } from '@project/components/atoms';
import { MagazineViewerModal } from '@project/components/molecules';
import { MagazineListItemType } from '@project/queries';

type MagazineCardProps = {
  magazine: MagazineListItemType;
  onSubscribe: () => void;
};

export const MagazineCard: React.FC<MagazineCardProps> = ({ magazine, onSubscribe }) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openContent = () => {
    if (magazine.isLocked) {
      onSubscribe();
      return;
    }
    if (magazine.content) setIsViewerOpen(true);
  };

  return (
    <Card className="relative flex flex-col p-5">
      <div className="relative">
        <div
          className={`flex h-44 flex-col items-center justify-center rounded bg-articles-gray ${
            magazine.isLocked ? 'blur-sm' : ''
          }`}
        >
          <DocumentTextIcon className="h-16 w-16 text-gold" />
          <span className="mt-2 px-3 text-center text-sm font-semibold text-gray-700">
            {magazine.name}
          </span>
        </div>

        {magazine.isLocked && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 rounded bg-black/40">
            <LockClosedIcon className="h-10 w-10 text-white" />
            <Button
              style="bg-gold text-white font-bold text-sm py-2 px-4 rounded"
              onClick={onSubscribe}
            >
              Subscribe to read
            </Button>
          </div>
        )}
      </div>

      <div className="mt-4 flex items-center justify-between">
        <div className="flex flex-col">
          <span className="font-semibold text-gray-800">{magazine.name}</span>
          <span className="text-xs text-gray-400">{magazine.datePublished}</span>
        </div>
        {magazine.paid ? (
          <span className="rounded-full bg-gold/20 px-2 py-0.5 text-xs text-gold">Paid</span>
        ) : (
          <span className="rounded-full bg-gray-200 px-2 py-0.5 text-xs text-gray-600">Free</span>
        )}
      </div>

      <div className="mt-4 flex justify-end">
        <Button
          style="border border-gold text-gold font-bold text-sm py-2 px-4 rounded"
          variant="outlined"
          onClick={openContent}
        >
          {magazine.isLocked ? 'Subscribe' : 'Read'}
        </Button>
      </div>

      {magazine.content && (
        <MagazineViewerModal
          isOpen={isViewerOpen}
          onClose={() => setIsViewerOpen(false)}
          name={magazine.name}
          magazineId={magazine.id}
        />
      )}
    </Card>
  );
};
